import React from "react";

import LoginRegisterPasswords from "../../components/login-register-passwords/login-register-passwords.component";
const RegisterFail = () => {
  return <LoginRegisterPasswords register='fail' />;
};
export default RegisterFail;
